"use strict";

angular.module("vendor")
.factory("SaleRepresentativeAssignedFactory", function($resource, FlashBag, appConfig) {

        var salesRepAssignedResource = $resource(appConfig.API_SERVER + "/sales-representatives/manage-customers/:id/", {
            id: "@id"
        }, {
            delete: {
                method: "DELETE",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });

        return {
            get: function(id) {
                var params = {
                    id: id
                };
                return salesRepAssignedResource.get(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );

            },
            delete: function(id) {
                return salesRepAssignedResource.delete({id: id}).$promise;
            }
        }
    }
);



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative-assigned.factory.js
// module id = 886
// module chunks = 0